<script lang="ts">
    import { usersStore } from "../../../../../store/users";

    $: currentPage = $usersStore.users.page + 1;
    $: previousPage = $usersStore.users.page;
    $: nextPage = $usersStore.users.page + 2;
    $: lastPage =
        $usersStore.users.totalElements % $usersStore.users.size === 0
            ? $usersStore.users.totalElements / $usersStore.users.size
            : Math.ceil(
                  $usersStore.users.totalElements / $usersStore.users.size
              );
</script>

<!-- svelte-ignore a11y-missing-attribute -->
<div class="column is-10 is-offset-1">
    <nav
        class="pagination is-centered is-rounded"
        role="navigation"
        aria-label="pagination"
    >
        <a
            class="pagination-previous gradient-left"
            on:click={() => usersStore.getPrevPage($usersStore)}>Vorherige</a
        >
        <a
            class="pagination-next gradient-left"
            on:click={() => usersStore.getNextPage($usersStore)}>Weiter</a
        >
        <ul class="pagination-list">
            {#if currentPage > 1}
                {#if currentPage > 2}
                    <li>
                        <a
                            class="pagination-link"
                            on:click={() =>
                                usersStore.getFirstPage($usersStore)}>1</a
                        >
                    </li>
                    {#if currentPage > 3}
                        <li>
                            <span class="pagination-ellipsis">&hellip;</span>
                        </li>
                    {/if}
                {/if}
                <li>
                    <a
                        class="pagination-link"
                        on:click={() => usersStore.getPrevPage($usersStore)}
                        >{previousPage}</a
                    >
                </li>
            {/if}
            <li>
                <a class="pagination-link is-current gradient-left"
                    >{currentPage}</a
                >
            </li>
            {#if currentPage < lastPage}
                <li>
                    <a
                        class="pagination-link"
                        aria-label="Goto page 47"
                        on:click={() => {
                            usersStore.getPageNumbered(
                                $usersStore,
                                nextPage - 1
                            );
                        }}>{nextPage}</a
                    >
                </li>
                {#if currentPage < lastPage - 1}
                    {#if currentPage < lastPage - 2}
                        <li>
                            <span class="pagination-ellipsis">&hellip;</span>
                        </li>
                    {/if}
                    <li>
                        <a
                            class="pagination-link"
                            aria-label="Goto page 86"
                            on:click={() => usersStore.getLastPage($usersStore)}
                            >{lastPage}</a
                        >
                    </li>
                {/if}
            {/if}
        </ul>
    </nav>
</div>
